"use client";

import { useEffect, useSyncExternalStore, type ReactNode } from "react";
import { installedModules } from "@/modules/registry.generated";
import { useBlock } from "../blocks/context";
import { hasThemeHeaderSlot, registerThemeHeaderSlot, serverHasThemeHeaderSlot, subscribeHeaderSlots } from "./header-slots";

/** Place an enabled module's public action directly inside theme header markup. */
export function ModuleHeaderAction({ moduleId }: { moduleId: string }) {
  const context = useBlock();
  const module = installedModules.find((candidate) => candidate.id === moduleId
    && context.enabledModules.includes(candidate.id) && candidate.capabilities.includes("site")
    && Object.keys(candidate.dependencies).every((id) => context.enabledModules.includes(id)));
  const Component = module?.headerComponent;
  const active = !context.editing && Boolean(Component);
  useEffect(() => active ? registerThemeHeaderSlot(moduleId) : undefined, [active, moduleId]);
  return active && Component ? <Component locale={context.locale} /> : null;
}

export function FallbackModuleHeaderAction({ moduleId, children }: { moduleId: string; children: ReactNode }) {
  const inTheme = useSyncExternalStore(subscribeHeaderSlots, () => hasThemeHeaderSlot(moduleId), serverHasThemeHeaderSlot);
  return inTheme ? null : children;
}
